export default "__VITE_ASSET__ChTdktY$__"